import React from 'react';
import { Column } from "rbx";
import "../../../styles/user.scss";
import Layout from "../../layout";
import UserForm from '../../../components/components/UserForm';

const UserEditScreen = () => (
  <Layout>
    <Column.Group centered>
      <Column size={5}>
        <UserForm editRecord={true} />
      </Column>
    </Column.Group>
  </Layout>
);

export default UserEditScreen;
